import { FilterTagAlternate } from '@aibees/elephant/feature/search-filters/components/filter-tags';

export function useIsAppliedFiltersEmpty(data: FilterTagAlternate[]) {
  return data.some((x) => !x.empty);
}
